import {Exclude, Expose, Type} from 'class-transformer';
import {InstagramMediaItemApiModel} from './instagram-media-item.api-model';

@Exclude()
export class ProjectInstagramMediaResponseApiModel {
  @Expose() public profileUrl: string | null;
  @Expose() public userProfileUrl: string | null;
  @Expose() public syncSources: string[] = [];
  @Expose() public linkedUsername: string | null;
  @Expose() public integrationStatus: string;
  @Expose() public profileMismatch: boolean;
  @Expose() public profileMismatchDetails: Array<{source: 'user' | 'project'; expectedUsername: string; linkedUsername: string}> = [];
  @Expose() public limitations: string[] = [];
  @Expose() @Type(() => InstagramMediaItemApiModel) public items: InstagramMediaItemApiModel[] = [];
}
